// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-social-share{display:flex;justify-content:space-between;margin:auto;width:11.25rem}.g-social-share__link{align-items:center;border:thin solid rgb(var(--grey-20));border-radius:50%;display:flex;height:2.8125rem;justify-content:center;width:2.8125rem}@media (min-width:768px){.g-social-share{flex-direction:column;height:11.25rem;width:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
